import { DefaultPage } from './';
export default {
  path: 'import/:version/v',
  name: 'Import',
  childRoutes: [
    {
      path: 'default-page',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
      isPrivate: true,
    },
  ],
};
